/* eslint-disable max-lines-per-function */
import { Growl } from 'primereact/growl';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { MultiSelect } from 'primereact/multiselect';
import React, { useContext, useEffect, useRef, useState } from 'react';
import cidadesEstadosService from '../../../services/cidades-estados/cidades-estados-service';
import { showErrorMessage, showSuccessMessage, showWarnMessage } from '../helper/primereactMessages';
import { IoMdAddCircleOutline } from 'react-icons/io';
import { MdDeleteForever } from 'react-icons/md';
import EdicaoPrecoMensalidadeContext from '../context/EdicaoMensalidadeContext';
import { unidadesFederativas } from '../helper/estados';
import { BuscarProduto } from '../../../services/produtos';

export default function DataTableMensalidadeLote({ messageRef,loadingChamadaBackend }) {
    const { lotePrecoMensalidadeContextState, setLotePrecoMensalidadeContextState } = useContext(EdicaoPrecoMensalidadeContext);
    const dt = useRef(null);
    const [loading, setLoading] = useState(false);
    const [planos, setPlanos] = useState();
    const [planoSelecionado, setPlanoSelecionado] = useState();
    const [cidades, setCidades] = useState();
    const [cidadeSelecionada, setCidadeSelecionada] = useState();
    const [estados, setEstados] = useState();
    const [estadoSelecionado, setEstadoSelecionado] = useState();
    const [planosSelecionados, setPlanosSelecionados] = useState([]);
    const [globalFilter, setGlobalFilter] = useState();
    const loadPlanos = async () => {
        let planos = (await BuscarProduto())?.map(item =>
            item.SubGrupo.trim());

        planos = [...new Set(planos)].map(item => ({ label: item.toUpperCase(),
            value: item }));

        setPlanos(planos);
    };

    const limparEstadosTabela = () => {
        setCidadeSelecionada(null);
        setEstadoSelecionado(null);
        setPlanoSelecionado(null);
        setPlanosSelecionados([]);
        setGlobalFilter(null);
    };

    useEffect(() => {
        if (lotePrecoMensalidadeContextState.limparEstadosTabela){
            limparEstadosTabela();
            setLotePrecoMensalidadeContextState({ ...lotePrecoMensalidadeContextState,
                limparEstadosTabela:false });
        }
    }, [lotePrecoMensalidadeContextState.limparEstadosTabela]);

    const validarRegrasPlanoZTA = (plano, planosSelecionados) => {
        if (plano === 'ZTA' && planosSelecionados.length) {
            throw new Error('Plano ZTA não pode ser adicionado se já existirem outros planos na lista');
        }

        const ztaJaSelecionado = planosSelecionados.some(planoSelecionado => planoSelecionado.plano === 'ZTA');

        if (plano !== 'ZTA' && ztaJaSelecionado) {
            throw new Error('Não é possível adicionar outros planos quando ZTA já está selecionado');
        }
    };

    const adicionarPlano = () => {
        const adicionarPlanos = [];
        const planosJaExistentes = [];

        try {
            if (!cidadeSelecionada.length) {
                throw new Error('Selecione uma cidade');
            }

            if (cidadeSelecionada.length === 1) {
                const plano = {
                    plano: planoSelecionado[0],
                    estado: estadoSelecionado[0],
                    cidade: cidadeSelecionada[0]
                };

                validarRegrasPlanoZTA(planoSelecionado[0], planosSelecionados);

                if (!checarSeExiste(plano)) {
                    setPlanosSelecionados([...planosSelecionados, plano]);
                    setLotePrecoMensalidadeContextState({ ...lotePrecoMensalidadeContextState,
                        planosSelecionados:[...planosSelecionados, plano] });
                    showSuccessMessage(messageRef,
                        'Plano adicionado adicionado na lista para alterações'
                    );

                    return;
                } else {
                    throw new Error('Plano já adicionado na lista para alterações');
                }
            }

            validarRegrasPlanoZTA(planoSelecionado[0], planosSelecionados);

            for (const cidadePlano of cidadeSelecionada) {
                const plano = {
                    plano: planoSelecionado[0],
                    estado: estadoSelecionado[0],
                    cidade: cidadePlano
                };

                if (!checarSeExiste(plano)) {
                    adicionarPlanos.push(plano);
                } else {
                    planosJaExistentes.push(plano);
                }
            }

            if (planosJaExistentes.length === cidadeSelecionada.length) {
                throw new Error('Planos já adicionados na lista para alterações');
            }

            setPlanosSelecionados([...planosSelecionados, ...adicionarPlanos]);
            setLotePrecoMensalidadeContextState({ ...lotePrecoMensalidadeContextState,
                planosSelecionados:[...planosSelecionados, ...adicionarPlanos] });
            showSuccessMessage(messageRef,'Planos adicionados na lista para alterações');

            return;
        } catch (error) {
            showWarnMessage(messageRef,error.message);

            return error;
        }
    };

    const deletarPlano = plano => {
        const indexPlano = planosSelecionados.indexOf(plano);

        setPlanosSelecionados(
            planosSelecionados.filter((_, index) => index !== indexPlano)
        );
        setLotePrecoMensalidadeContextState({ ...lotePrecoMensalidadeContextState,
            planosSelecionados:planosSelecionados.filter((_, index) => index !== indexPlano) });
        showSuccessMessage(messageRef,'Plano deletado da lista para alterações');
    };

    const limparTodosPlanos = () => {
        setPlanosSelecionados([]);
        setLotePrecoMensalidadeContextState({ ...lotePrecoMensalidadeContextState,
            planosSelecionados: [] });
        showSuccessMessage(messageRef,'Planos deletados da lista para alterações');
    };

    const changeMultiSelectPlano = e => {
        if (e.value.length > 0) {
            setPlanoSelecionado([e.value[e.value.length - 1]]);
        }
    };

    const changeMultiSelectEstado = e => {
        if (e.value.length > 0) {
            setEstadoSelecionado([e.value[e.value.length - 1]]);
        }
    };

    const changeMultiSelectCidade = e => {
        setCidadeSelecionada(e.value);
    };

    const checarSeExiste = plano => {
        if (planosSelecionados.length === 0) {
            return false;
        }

        for (const item of planosSelecionados) {
            if (
                item.plano === plano.plano &&
                item.estado === plano.estado &&
                item.cidade === plano.cidade
            ) {
                return true;
            }
        }

        return false;
    };

    const loadEstados = async () => {
        const estados = unidadesFederativas.map(item => ({ label: item.nome,
            value: item.sigla }));

        setEstados(estados);
    };

    const loadInicial = async () => {
        try {
            setLoading(true);
            await loadEstados();
            await loadPlanos();
            showSuccessMessage(messageRef,'Planos e Estados carregados com sucesso!');
            setLoading(false);
        } catch (error) {
            showErrorMessage(messageRef,
                error.message ?
                    error.message :
                    'Algo deu errado, tente novamente mais tarde!'
            );

            return Error(error.message);
        }
    };

    useEffect(() => {
        loadInicial();
    }, []);

    useEffect(() => {
        const loadCidades = async () => {
            try {
                setLoading(true);

                const cidades = (
                    await cidadesEstadosService.getCidadesEstado(estadoSelecionado[0])
                ).map(item => ({
                    label: item.nome,
                    value: { id: item.id,
                        label: item.nome }
                }));

                setCidades(cidades);
                showSuccessMessage(messageRef,'Cidades carregadas com sucesso!');
                setLoading(false);
            } catch (error) {
                showErrorMessage(
                    error.message ?
                        error.message :
                        'Algo deu errado, tente novamente mais tarde!'
                );
                setLoading(false);
            }
        };

        if (estadoSelecionado) {
            loadCidades();
        }
    }, [estadoSelecionado]);

    useEffect(() => {
        const clearCidades = async () => {
            setCidadeSelecionada([]);
        };

        clearCidades();
    }, [cidades]);

    const renderHeader = () => (
        <div className="header-table-cadastro-edicao-precos">
            <div className="title-header-table-cadastro">
                <h2>Planos Selecionados</h2>
                <p>Todos planos selecionados receberão as configurações</p>
            </div>
            <div className="menu-header-table-cadastro">
                <input
                    placeholder="Faça uma busca global"
                    value={globalFilter}
                    onChange={e => setGlobalFilter(e.target.value)}
                    className="input-empty"
                />
                <button
                    disabled={planosSelecionados.length === 0 || loadingChamadaBackend}
                    onClick={limparTodosPlanos}
                >
                    <MdDeleteForever size={20} color="white" />
                    <span>Deletar tudo</span>
                </button>
            </div>
        </div>
    );

    const actionBodyTemplate = rowData => (
        <div className="actions-table-cadastro-edicao-precos">
            <button
                onClick={() => deletarPlano(rowData)}
                disabled={loadingChamadaBackend}
            >
                <MdDeleteForever size={18} />
                <span>Deletar</span>
            </button>
        </div>
    );

    return ( <div className="page-cadastro-edicao-precos-lote">
        <Growl ref={messageRef} />
        <div className="div-title-cadastro-edicao-precos">
            <div className="traco-vertical"></div>
            <div className="title-cadastro-edicao-precos">
                <h1>Cadastro e edição de mensalidades por plano</h1>
                <p>
                        Selecione todos os planos que deseja incluir ou alterar de uma
                        vez só
                </p>
            </div>
        </div>

        <div className="form-cadastro-edicao-precos">
            <MultiSelect
                value={planoSelecionado}
                options={planos}
                onChange={changeMultiSelectPlano}
                filter={true}
                filterPlaceholder="Procurar"
                placeholder="Escolha um plano"
                className="select-cadastro-edicao-precos"
                disabled={loadingChamadaBackend}
            />
            <MultiSelect
                value={estadoSelecionado}
                options={estados}
                onChange={changeMultiSelectEstado}
                filter={true}
                filterPlaceholder="Procurar"
                placeholder="Escolha um estado"
                className="select-cadastro-edicao-precos"
                disabled={loadingChamadaBackend}
            />
            <MultiSelect
                value={cidadeSelecionada}
                options={cidades}
                onChange={changeMultiSelectCidade}
                maxSelectedLabels={3}
                selectedItemsLabel={'{0} itens selecionados'}
                filter={true}
                filterPlaceholder="Procurar"
                placeholder="Escolha uma cidade"
                className="select-cadastro-edicao-precos-cidades"
                disabled={!estadoSelecionado || loadingChamadaBackend}
            />
            <button
                onClick={adicionarPlano}
                disabled={
                    !planoSelecionado ||
                        !estadoSelecionado ||
                        !cidadeSelecionada ||
                        loadingChamadaBackend
                }
                className="form-cadastro-edicao-precos-button"
            >
                <IoMdAddCircleOutline size={25} color="white" />
                <span>Adicionar</span>
            </button>
        </div>

        <div className="table-cadastro-edicao-precos">
            <DataTable
                ref={dt}
                loading={loading}
                value={planosSelecionados}
                responsive
                dataKey="Referencia"
                rowHover
                globalFilter={globalFilter}
                header={renderHeader()}
                paginator
                rows={5}
                emptyMessage="Ainda não há planos selecionados"
                currentPageReportTemplate="Exibindo {first} a {last} de {totalRecords} resultados encontrados"
                paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
                rowsPerPageOptions={[5, 10]}
            >
                <Column
                    field="plano"
                    header="Plano"
                    filter
                    filterPlaceholder="Buscar plano dentre os selecionados"
                />
                <Column
                    field="estado"
                    header="Estado"
                    filter
                    filterPlaceholder="Buscar estado dentre os selecionados"
                />
                <Column
                    field="cidade.label"
                    header="Cidade"
                    filter
                    filterPlaceholder="Buscar cidade dentre as selecionados"
                />
                <Column
                    body={actionBodyTemplate}
                    headerStyle={{ width: '8em',
                        textAlign: 'center' }}
                    bodyStyle={{ textAlign: 'center',
                        overflow: 'visible' }}
                />
            </DataTable>
        </div>
    </div>
    );
}
